var Message = /** @class */ (function () {
    function Message(props) {
        Object.assign(this, props);
    }
    return Message;
}());
export { Message };
export var MessageType = {
    Error: 'error',
    Warning: 'warning'
};
var LoaderData = /** @class */ (function () {
    function LoaderData(props) {
        Object.assign(this, props);
    }
    return LoaderData;
}());
export { LoaderData };



//////////////////
// WEBPACK FOOTER
// ./src/modules/UI/Model.ts
// module id = 1054
// module chunks = 0